import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiUrls } from "./ApiUrls";
import { Page } from "../model/Page";
import { UserModel } from "../model/UserModel";
import { OrganizationRequestModel } from "../model/OrganizationRequestModel";
import { OrganizationResponseModel } from "../model/OrganizationResponseModel";
import { BoardResponseModel } from "../model/BoardResponseModel";
import { BoardRequestModel } from "../model/BoardRequestModel";
import { FeatureResponseModel } from "../model/FeatureResponseModel";
import { FeatureRequestModel } from "../model/FeatureRequestModel";
import { RoleRequestModel } from "../model/RoleRequestModel";
import { RoleResponseModel } from "../model/RoleResponseModel";
import { FeatureForRoleResponse } from "../model/FeatureForRoleResponse";
import { UserRequestModel } from "../model/UserRequestModel";
import { UserResponseModel } from "../model/UserResponseModel";
import { LotteryRequestModel } from "../model/LotteryRequestModel";
import { MatSnackBar } from "@angular/material/snack-bar";
// import { LotteryResponseModel } from '../model/LotteryResponseModel';
import { LotteryFormResponse } from "../model/LotteryFormResponse";
import { LotteryResponseModel } from "../model/LotteryResponseModel";
import { FileResponseModel } from "../model/FileResponseModel";
import { AnnouncementResponseModel } from "../model/AnnouncementResponseModel";
import { AnnouncementRequestModel } from "../model/AnnouncementRequestModel";
import { AnnouncementFormResponse } from "../model/AnnouncementFormResponse";
import { ApplicationsListResponseModel } from "../model/ApplicationsListResponseModel";
import { BoardFormResponse } from "../model/BoardFormResponse";
import { AppointmentSlotModel } from "../model/AppointmentSlotModel";
import { BoardResponse } from "../model/BoardResponse";
import { AuthorityResponse } from "../model/AuthorityResponse";
import { WalkinAppointmentListModel } from "../model/WalkinAppointmentListModel";

@Injectable({
  providedIn: "root",
})
export class MasterService {
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) {}

  fetchRoleList(page: number, size: number, filterText?: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<RoleResponseModel>>(
      ApiUrls.roleList + reqParams
    );
  }

  initRoleForm() {
    return this.httpClient.get<{
      roleTypes: string[];
      features: FeatureForRoleResponse[];
    }>(`${ApiUrls.initRoleFormUrl}`);
  }

  initBoardForm() {
    return this.httpClient.get<BoardFormResponse>(ApiUrls.initBoardForm);
  }

  saveRole(role: RoleRequestModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveRole}`,
      role
    );
  }

  getRoleBykey(roleKey: number) {
    return this.httpClient.get<RoleResponseModel>(
      ApiUrls.getRoleByKeyUrl.replace("{roleKey}", roleKey.toString())
    );
  }

  updateRole(roleKey: number, role: RoleRequestModel) {
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateRoleUrl.replace("{roleKey}", roleKey.toString())}`,
      role
    );
  }

  toggleActivationRole(roleKey: number, activeFlag: string) {
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.toggleActivationRoleUrl.replace("{roleKey}", roleKey.toString()),
      {
        activeFlag,
      }
    );
  }

  fetchUserList(page: number, size: number, filterText?: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<UserModel>>(ApiUrls.userList + reqParams);
  }


  initUserForm() {
    return this.httpClient.get<{
      roles: { [key: number]: string };
      boards: { [key: number]: string };
      boardWiseDepartments: { [key: number]: { [key: number]: string } };
      departmentWiseDesignations: { [key: number]: { [key: number]: string } };
    }>(`${ApiUrls.initUserFormUrl}`);
  }

  saveUser(user: UserRequestModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveUser}`,
      user
    );
  }

  updatePassword(password: string) {
    console.log("Inner Method", password);

    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.updatePassword}`,
      {
        password,
      }
    );
  }



  getUserBykey(userKey: number) {
    return this.httpClient.get<UserResponseModel>(
      ApiUrls.getUserByKeyUrl.replace("{userKey}", userKey.toString())
    );
  }

  updateUser(userKey: number, user: UserRequestModel) {
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateUserUrl.replace("{userKey}", userKey.toString())}`,
      user
    );
  }

  toggleActivationUser(userKey: number, activeFlag: string) {
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.toggleActivationUserUrl.replace("{userKey}", userKey.toString()),
      {
        activeFlag,
      }
    );
  }

  deactiveSop(key: number, activeFlag: string) {
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.deleteSop.replace("{key}", key.toString()),
      {
        key,
        activeFlag,
      }
    );
  }

  resetUserPassword(userKey: number) {
    return this.httpClient.get<{ status: string; errorMessage: string }>(
      ApiUrls.resetUserPasswordUrl.replace("{userKey}", userKey.toString())
    );
  }

  changeDefaultPassword(password: string) {
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateDefaultPasswordUrl}`,
      {
        password: password,
      }
    );
  }

  // deActivateUser(key: number) {
  //   return this.httpClient.patch<{status: string, errorMessage: string}>(ApiUrls.userList + reqParams);
  // }

  getOrgList() {
    console.log("this is comming from organisation service");
    return this.httpClient.get<Page<OrganizationResponseModel>>(
      `${ApiUrls.organizationList}`
    );
  }

  saveOrg(organization: OrganizationRequestModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveOrg}`,
      organization
    );
  }

  getOrgBykey(orgkey: number) {
    return this.httpClient.get<OrganizationResponseModel>(
      ApiUrls.getOrgByKeyUrl.replace("{organizationKey}", orgkey.toString())
    );
  }

  updateOrg(organizationKey: number, organization: OrganizationRequestModel) {
    console.log(
      "this is comming from organization service***** Update call **** ",
      organization
    );
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateOrgUrl.replace(
        "{organizationKey}",
        organizationKey.toString()
      )}`,
      organization
    );
  }

  deactivareOrg(organizationKey: number, activeFlag: string) {
    console.log(
      "this is comming from organization service***** Deactivate call **** " +
        organizationKey +
        "  flag " +
        activeFlag
    );
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.activeDactiveOrgUrl.replace(
        "{organizationKey}",
        organizationKey.toString()
      ),
      {
        activeFlag,
      }
    );
  }

  getFeatureList(page: number, size: number, filterText?: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<FeatureResponseModel>>(
      `${ApiUrls.featureList}` + reqParams
    );
  }

  initFeatureForm() {
    return this.httpClient.get<{
      parentFeatureList: { [key: number]: string };
    }>(`${ApiUrls.initFeatureFormUrl}`);
  }

  saveFeature(feature: FeatureRequestModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveFeature}`,
      feature
    );
  }

  getFeatureBykey(featureKey: number) {
    return this.httpClient.get<FeatureResponseModel>(
      ApiUrls.getFeatureByKeyUrl.replace("{featureKey}", featureKey.toString())
    );
  }

  updateFeature(featureKey: number, feature: FeatureRequestModel) {
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateFeatureUrl.replace(
        "{featureKey}",
        featureKey.toString()
      )}`,
      feature
    );
  }

  toggleActivationFeature(featureKey: number, activeFlag: string) {
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.toggleActivationFeatureUrl.replace(
        "{featureKey}",
        featureKey.toString()
      ),
      {
        activeFlag,
      }
    );
  }

  getBoardList() {
    console.log("this is comming from Master service Get board list");
    return this.httpClient.get<Page<BoardResponseModel>>(
      `${ApiUrls.boardList}`
    );
  }

  saveBoard(board: BoardRequestModel) {
    console.log("this is comming from Master service save board");
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveBoard}`,
      board
    );
  }

  getBoardBykey(boardkey: number) {
    console.log(
      "this is comming from Master service Get board by key " + boardkey
    );
    return this.httpClient.get<BoardResponseModel>(
      ApiUrls.getBoardByKeyUrl.replace("{boardKey}", boardkey.toString())
    );
  }

  updateBoard(boardkey: number, board: BoardRequestModel) {
    console.log(
      "this is comming from master service for ***** Update Board call **** ",
      board
    );
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateBoardUrl.replace("{boardKey}", boardkey.toString())}`,
      board
    );
  }

  deactivateBoard(boardkey: number, activeFlag: string) {
    console.log(
      "this is comming from master service***** Deactivate call **** " +
        boardkey +
        "  flag " +
        activeFlag
    );
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.activeDactiveBoardUrl.replace("{boardKey}", boardkey.toString()),
      {
        activeFlag,
      }
    );
  }


  //For Announcement
  fetchAnnouncementList(page: number, size: number, filterText?: string) {
    console.log("in master service get call");
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<AnnouncementResponseModel>>(
      ApiUrls.announcementList + reqParams
    );
  }

  toggleActivationAnnouncement(announcementKey: number, activeFlag: string) {
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.toggleActivationAnnouncementUrl.replace(
        "{announcementKey}",
        announcementKey.toString()
      ),
      {
        activeFlag,
      }
    );
  }

  initAnnouncementForm(announcementKey: number) {
    let announcementKeyParam = announcementKey
      ? `?announcementKey=${announcementKey}`
      : "";
    return this.httpClient.get<AnnouncementFormResponse>(
      ApiUrls.initAnnouncementForm + announcementKeyParam
    );
  }

  saveAnnouncement(announcement: AnnouncementRequestModel) {
    console.log("this is comming from Master service save Announcement");
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveAnnouncement}`,
      announcement
    );
  }

  getAnnouncementBykey(announcementKey: number) {
    console.log(
      "this is comming from Master service Get Lottery by key " +
        announcementKey
    );
    return this.httpClient.get<AnnouncementResponseModel>(
      ApiUrls.getAnnouncementByKeyUrl.replace(
        "{announcementKey}",
        announcementKey.toString()
      )
    );
  }

  updateAnnouncement(
    announcementKey: number,
    announcement: AnnouncementRequestModel
  ) {
    console.log(
      "this is comming from master service for ***** Update Lottery call **** ",
      announcement
    );
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateAnnouncementUrl.replace(
        "{announcementKey}",
        announcementKey.toString()
      )}`,
      announcement
    );
  }


  async successToast(msg) {
    await this._snackBar.open(msg, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  getAppointmentByKey(appointmentKey: number) {
    return this.httpClient.get<AppointmentSlotModel>(
      ApiUrls.getAppointmentByKeyUrl.replace(
        "{appointmentKey}",
        appointmentKey.toString()
      )
    );
  }

  saveSlotOpening(user: AppointmentSlotModel) {
    console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>appointmentdate+++", user);
   return this.httpClient.post<{ status: string; errorMessage: string }>(
     `${ApiUrls.saveSlotOpening}`,
     user
   );
 }

//  fetchWalkinAppointmentList(page: number, size: number, filterText?: string) {
//   let reqParams =
//     `?page=${page}&size=${size}` +
//     (filterText ? `&filterText=${filterText}` : "");
//   return this.httpClient.get<Page<WalkinAppointmentListModel>>(ApiUrls.walkinAppointmentListUrl + reqParams);
// }

fetchWalkinAppointmentList(
  page: number,
  size: number,
  filterText?: string,
  startDate?: string,
  endDate?: string,
  reasonFilter?: string
) {
  console.log('Start Date:', startDate);
  console.log('End Date:', endDate);
  console.log('reasonFilter:', reasonFilter);

  let reqParams =
    `?page=${page}&size=${size}` +
    (filterText ? `&filterText=${filterText}` : "") +
    (startDate ? `&startDate=${startDate}` : "") +
    (endDate ? `&endDate=${endDate}` : "") +
    // (status ? `&status=${status}` : "")+
    (reasonFilter ? `&reasonFilter=${reasonFilter}` : "");


  return this.httpClient.get<Page<WalkinAppointmentListModel>>(ApiUrls.walkinAppointmentListUrl + reqParams);
}



// downloadGatePassWalkin(key: number, selectedLanguageHeader: string) {
//   return this.httpClient.get<{ data: string, status: string, errorMessage: string }>(
//     ApiUrls.walkinAppointmentDownloadGatePassUrl.replace("{key}", key.toString()), 
//     {
//       params: {
//         language: selectedLanguageHeader   // 👈 pass language as query param
//       }
//     }
//   );
// }

downloadGatePassWalkin(key: number) {
  return this.httpClient.get<{ data: string, status: string, errorMessage: string }>(
    ApiUrls.walkinAppointmentDownloadGatePassUrl.replace("{key}", key.toString()), 
  );
}

// downloadGatePassWalkin(key: number, lang: string) {
//   const headers = {
//     'Accept-Language': lang
//   };
//   return this.httpClient.get<{ data: string, status: string, errorMessage: string }>(
//     ApiUrls.walkinAppointmentDownloadGatePassUrl.replace("{key}", key.toString()), 
//     { headers }
//   );
// }



 submitWalkinDetails(data: any) {
  console.log('>>>> Submitting Walk-in payload >>>>', data);
  return this.httpClient.post<{ status: string; errorMessage: string }>(
    `${ApiUrls.saveWalkinDetails}`,
    data
  );
}
 fetchAppointmentDtl(page: number, size: number, filterText?: string) {
  let reqParams =
    `?page=${page}&size=${size}` +
    (filterText ? `&filterText=${filterText}` : "");
  return this.httpClient.get<Page<AppointmentSlotModel>>(
    ApiUrls.fetchAppointmentDtl + reqParams
  );
}
 updateSlotOpening(appointmentKey: number, user: AppointmentSlotModel) {
   return this.httpClient.post<{ status: string; errorMessage: string }>(
     `${ApiUrls.updateSlotOpening.replace(
       "{appointmentKey}",
       appointmentKey.toString()
     )}`,
     user
   );
 }

 toggleActivationAppointment(appointmentKey: number, activeFlag: string) {
  return this.httpClient.patch<{ status: string; errorMessage: string }>(
    ApiUrls.toggleActivationAppointmentUrl.replace(
      "{appointmentKey}",
      appointmentKey.toString()
    ),
    {
      activeFlag,
    }
  );
}

fetchBoardList() {
  return this.httpClient.get<BoardResponse>(ApiUrls.fetchBoardList);
}


fetchAuthorityListInit(boardKey: number) {
  return this.httpClient.get<AuthorityResponse>(
    ApiUrls.authorityList + "/" + boardKey 
  );
}

fetchWalkinDetailsByMobile(mobileNumber: string) {
  return this.httpClient.get<any>(`${ApiUrls.fetchWalkinDetailsByMobile}/${mobileNumber}`);
}


// fetchAuthorityListInit(
//   boardKey: string
// ) {
//   ApiUrls.authorityList
//   return this.httpClient.get<AuthorityResponse>(
//     `${ApiUrls.authorityList
//       .replace("{boardKey}", boardKey)
//     }`,
//     null
//   );
// }
}

